import { axios } from "../axios"

export const apiAbout = {
    getAboutContent: (lang) => axios.get(`/about?locale=${lang}`)
}